export default __webpack_public_path__ + "static/media/photo.e5645e40.svg";